import Contribution from '@/classes/contributions/Contribution'

export default class Contributions extends Array {
  constructor (contributions, ...rest) {
    Array.isArray(contributions) ? super(...contributions.map(contribution => new Contribution(contribution))) : super(...rest)
  }
}
